__turbopack_context__.v({
  "spinning": "Spinner-module-scss-module__mGxLBG__spinning",
});
